module.exports = __webpack_public_path__ + "img/Sketching.dcfbb07f.svg";